// TODO: source MONTHLY_PRICE_CENTS + currency from /subscription/plans rather
// than hardcoding here. Until then, the display omits the currency code so we
// don't silently assert ZAR.
export const MONTHLY_PRICE_CENTS = 7900;

export const MONTH_OPTIONS: Account.MonthOption[] = [
  { months: 1, label: '1 month' },
  { months: 3, label: '3 months' },
  { months: 6, label: '6 months' },
  { months: 12, label: '12 months' },
];

export const TESTIMONIALS: Account.Testimonial[] = [
  {
    name: 'Bongiwe Dlamini',
    title: 'Domestic Cleaner',
    flag: '🇿🇦',
    country: 'South Africa',
    rating: 5,
    quote:
      'I used to rely on word of mouth only. Since joining Kudable I get steady bookings every week and my clients even leave me reviews! 🙌',
  },
  {
    name: 'Sipho Mthembu',
    title: 'Plumber',
    flag: '🇿🇦',
    country: 'South Africa',
    rating: 5,
    quote:
      'Went from 2 jobs a month to 2 a week. The subscription pays for itself in the first booking honestly.',
  },
  {
    name: 'Nomsa Khumalo',
    title: 'Hair Stylist',
    flag: '🇿🇦',
    country: 'South Africa',
    rating: 5,
    quote:
      'My profile looks so professional now. Clients trust me before we even meet. Grown my business more in 3 months than 2 years on my own ✨',
  },
  {
    name: 'Thabo Mokoena',
    title: 'Electrician',
    flag: '🇿🇦',
    country: 'South Africa',
    rating: 4,
    quote:
      "Was sceptical at first but the first client I got through Kudable turned into a long-term contract. Best decision I've made.",
  },
  {
    name: 'Chidinma Okafor',
    title: 'Interior Decorator',
    flag: '🇳🇬',
    country: 'Nigeria',
    rating: 5,
    quote:
      "Kudable gave me visibility I couldn't get anywhere else. Clients now reach out to ME instead of the other way around 🎯",
  },
  {
    name: 'James Otieno',
    title: 'Painter',
    flag: '🇰🇪',
    country: 'Kenya',
    rating: 5,
    quote:
      "The reviews on my profile give new clients confidence. I've literally doubled my income since I started.",
  },
  {
    name: 'Priya Naidoo',
    title: 'Personal Trainer',
    flag: '🇬🇧',
    country: 'United Kingdom',
    rating: 5,
    quote:
      'Moved to the UK and needed to build a client base from scratch. Kudable made it so much easier, people find me and book directly 🚀',
  },
  {
    name: 'David Mensah',
    title: 'Carpenter',
    flag: '🇬🇧',
    country: 'United Kingdom',
    rating: 4,
    quote:
      'Clients can see my ratings before hiring which builds trust. Good platform for small tradespeople who need an online presence.',
  },
  {
    name: 'Maria Santos',
    title: 'House Cleaner',
    flag: '🇺🇸',
    country: 'United States',
    rating: 5,
    quote:
      'Was struggling to find consistent work. Within a month on Kudable I had a full weekly schedule. The platform just works 💯',
  },
  {
    name: 'Tatenda Moyo',
    title: 'Auto Mechanic',
    flag: '🇿🇼',
    country: 'Zimbabwe',
    rating: 5,
    quote:
      'Helped me reach customers outside my neighbourhood. Now getting jobs from across the city which is amazing.',
  },
  {
    name: 'Lucas Ferreira',
    title: 'Landscaper',
    flag: '🇧🇷',
    country: 'Brazil',
    rating: 4,
    quote:
      'Even in a competitive market Kudable helped me stand out. The professional profile and ratings make all the difference.',
  },
];
